module.exports = __webpack_public_path__ + "static/media/ga.35076ae6.svg";